import { useEffect, useState } from "react";
import styles from "./style.module.scss";
import WidgetSkeleton from "./WidgetSkeleton";

export type AngiWidgetDetails = {
    showWidget: boolean | undefined;
    cjLeadKey: string;
};

export type AngiWidgetState = "loading" | "widgetLoaded" | "thankYou";

export default function AngiWidget({
    angiWidgetDetails,
    onStateChange,
}: {
    angiWidgetDetails: AngiWidgetDetails;
    onStateChange?: (state: AngiWidgetState) => void;
}) {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!angiWidgetDetails.showWidget) {
            setLoading(false);
            onStateChange?.("thankYou");
            return;
        }
        const script = document.createElement("script");
        script.src = "https://request.angi.com/hcc/dropin-112a615a05e36545.js";

        const handleScriptLoad = () => {
            if (window?.initializeDropIn) {
                window.initializeDropIn(angiWidgetDetails.cjLeadKey);
            }
        };

        script.onload = handleScriptLoad;

        script.onerror = () => {
            setLoading(false);
            onStateChange?.("thankYou");
        };
        const handleMessage = (event: MessageEvent) => {
            const eventData = event.data as {
                event?: string;
                payload?: string;
            };
            if (eventData?.event === "pageState") {
                if (eventData.payload === "WidgetLoaded") {
                    setLoading(false);
                    onStateChange?.("widgetLoaded");
                }
                if (eventData.payload === "ThankYou") {
                    onStateChange?.("thankYou");
                }
            }
        };
        window.addEventListener("message", handleMessage);
        document.body.appendChild(script);

        return () => {
            window.removeEventListener("message", handleMessage);
            if (document.body.contains(script)) {
                document.body.removeChild(script);
            }
        };
    }, [
        angiWidgetDetails.showWidget,
        angiWidgetDetails.cjLeadKey,
        onStateChange,
    ]);

    return (
        <div className={`dropin-container ${styles["dropin-container"]}`}>
            {loading && <WidgetSkeleton />}
        </div>
    );
}
